module.exports = __webpack_public_path__ + "static/media/tti_reason_2@3x.ea67ee69.png";